<template>
	<div :class="classes">
		<div class="jon-info--message">
			<div>
				<Jon white/>
			</div>
			<slot name="message"/>
		</div>
		<div v-if="footerImage" class="jon-info--footer-image">
			<img :src="footerImage" alt="Abschluss-Bild"/>
		</div>
	</div>
</template>
<script>
import Jon from "@/vue/common/image/Jon";

export default {
	components: {Jon},

	props: {
		footerImage: {
			type: String,
			required: false
		}
	},

	computed: {
		classes ()
		{
			return {
				'jon-info': true
			}
		}
	}
}
</script>
